import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

export const ResetPassword = async (form) => {
  const response = await $api.post(Endpoints.CustomerUser.ResetPassword(), {
    token: form.token,
    newPassword: form.newPassword,
  });
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  ResetPassword,
};
